(() => {
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.stoa-reveal').forEach((el) => observer.observe(el));
  } else {
    document.querySelectorAll('.stoa-reveal').forEach((el) => el.classList.add('is-visible'));
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details || !details.matches('.stoa-mobile-menu')) return;
    document.querySelectorAll('.stoa-mobile-menu[open]').forEach((item) => {
      if (item !== details) item.removeAttribute('open');
    });
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open]').forEach((item) => item.removeAttribute('open'));
  });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.stoa-reveal').forEach((el) => el.classList.add('is-visible'));
  });
})();
